import { QueryClient } from '@tanstack/react-query'
import { cache } from 'react'

function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60_000,
        retry: 1,
      },
    },
  })
}

// Server: nova instância por requisição (React cache() é request-scoped no servidor)
export const getQueryClient = cache(createQueryClient)

// Cliente: usado pelo QueryProvider via useRef para instância estável por montagem
export function makeQueryClient() {
  return createQueryClient()
}
